<template>
    <div class="hero-homepage">
        <div class="hero-section">
            <H1 class="hero-text"
                >Instant Inland Marine Insurance for your Property</H1
            >
            <div class="menu-wrapper">
                <Link to="/get-quote" class="menu-item">
                    <font-awesome-icon :icon="['fas', 'tractor']" />
                    <P>Starting at <span>${{getMinimum}}</span> per year</P>
                    <Button class="navy">Buy Insurance</Button>
                    <font-awesome-icon
                        class="caret"
                        :icon="['fas', 'caret-up']"
                    />
                </Link>
            </div>
        </div>
        <div class="content-section-wrap">
            <div class="content-section">
                <h3>
                    Dremca makes buying Inland Marine insurance easy, fast, and
                    100% online.
                </h3>
                <p>
                    Instantly insure up to $100,000 of your personal or business
                    property, including:
                </p>
                <ul>
                    <li>Tractors and Attachments</li>
                    <li>Musical Instruments & Sound Equipment</li>
                    <li>Specialty Equipment</li>
                </ul>
                <p>
                    Our policy covers your property anywhere, including in
                    transit. For exclusions,
                    <a href="/faq">please refer to FAQ’s.</a>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import { Button, H1, Link } from "../style";
import { PROPERTY_LOCATIONS } from "../utils/constants";
export default {
  name: "Homepage",
  components: {
    Button,
    H1,
    Link
  },
  computed: {
    getMinimum() {
      let states = PROPERTY_LOCATIONS.filter(loc => {
        if (
          !loc.disabled &&
                    (loc.abbrev == "ME" ||
                        loc.abbrev == "NH" ||
                        loc.abbrev == "VT")
        ) {
          return loc;
        }
      });
      if (states.length > 0) {
        return "350";
      } else {
        return "500";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/style/_variables.scss";
.hero-homepage {
    background-color: $white;
}
.hero-section {
    background-color: $background-gray;
    padding: 2rem 2rem 4rem;
    margin-top: 3.875rem;
    height: auto;
    box-sizing: border-box;
    @media (max-width: $mobile-hd-width) {
        padding: 2rem 1rem 3rem;
    }
}
.hero-text {
    color: $blue-navy;
    font-size: $font-size-xxl;
    font-weight: 600;
    text-align: center;
}
.menu-wrapper {
    display: flex;
    justify-content: center;
}
.menu-item {
    position: relative;
    background-color: $white;
    max-width: 100%;
    width: 360px;
    height: 240px;
    border-radius: 8px;
    margin: $padding-xl 0 0 0;
    padding: $padding-xl;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 0 16px rgba(0, 0, 0, 0.12);
    border: 3px solid transparent;
    color: $blue-navy;
    transition: $transition-simple-fast;
    text-decoration: none;
    @include breakpoint(mobile-hd-width) {
        margin: $padding-xl;
    }
    &.disabled {
        cursor: default;
        &:hover {
            border-color: transparent;
            svg.caret {
                display: none;
            }
        }
    }
    &:hover {
        border-color: $blue-navy;
        svg.caret {
            display: block;
        }
    }
    svg {
        font-size: 64px;
        color: $blue-navy;
        &.caret {
            display: none;
            position: absolute;
            bottom: -70px;
        }
    }
    p {
        color: $dark-gray;
        margin: $padding-xl 0 0;
        span {
            font-weight: 600;
        }
    }
    button.navy {
        margin-top: $padding-xl;
    }
}
.content-section-wrap {
    background-color: $white;
    margin: auto;
    width: 100%;
}
.content-section {
    padding: $padding-lg $padding-lg $padding-xxl;
    height: auto;
    box-sizing: border-box;
    width: 100%;
    max-width: 800px;
    margin: auto;
    font-size: $font-size-md;
    color: $dark-gray;
    @include breakpoint(mobile-hd-width) {
        padding: $padding-xxl;
    }
    h3 {
        padding: $padding-lg 0;
        font-size: $font-size-lg;
        font-weight: 600;
        color: $dark-gray;
    }
    ul {
        line-height: 1.5;
    }
    a {
        &:visited {
            color: initial;
        }
        &:hover {
            text-decoration: none;
        }
    }
}
</style>
